import { render } from '@testing-library/react';
import React from 'react';
import VendorOnboarding from './VendorOnboarding';

jest.mock('./components/Form', () => () => '{Form}');
jest.mock('./components/Success', () => () => '{Success}');

describe('VendorOnboarding', () => {
  const renderVendorOnboarding = (props) =>
    render(<VendorOnboarding {...props} />);
  const props = {
    dealer: {},
    csrfToken: '<token>',
  };

  describe('FORM_SCREEN', () => {
    it('renders the component', () => {
      const { container } = renderVendorOnboarding(props);
      expect(container).toMatchSnapshot();
    });
  });

  describe('SUCCESS_SCREEN', () => {
    it('renders the component', () => {
      const { container } = renderVendorOnboarding({
        ...props,
        initialScreen: 'SUCCESS_SCREEN',
      });
      expect(container).toMatchSnapshot();
    });
  });
});
